import React from 'react';

export default function FlagOne() {
  return (
    <svg
      width='64'
      height='71'
      viewBox='0 0 64 71'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='#EAB308'
      />
      <path
        d='M57 10L52.1095 3.57688C51.353 2.58326 50.1758 2 48.927 2H14C12.8954 2 12 2.89543 12 4V10H57Z'
        fill='black'
        fill-opacity='0.5'
      />
      <g filter='url(#filter0_dd_8281_7967)'>
        <path
          d='M12 4C12 2.89543 12.8954 2 14 2H50C51.1046 2 52 2.89543 52 4V46.7639C52 48.2507 50.4354 49.2177 49.1056 48.5528L32.8944 40.4472C32.3314 40.1657 31.6686 40.1657 31.1056 40.4472L14.8944 48.5528C13.5646 49.2177 12 48.2507 12 46.7639V4Z'
          fill='url(#paint0_linear_8281_7967)'
        />
        <path
          d='M38.0666 11.6364L34.6859 32H29.774L32.399 16.2301H32.2797L27.2583 19.0142L27.9544 14.7585L33.5027 11.6364H38.0666Z'
          fill='url(#paint1_linear_8281_7967)'
        />
      </g>
      <defs>
        <filter
          id='filter0_dd_8281_7967'
          x='0'
          y='0'
          width='64'
          height='72'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='3'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_8281_7967'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='7.5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_8281_7967'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='4'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_8281_7967'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='3' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_8281_7967'
            result='effect2_dropShadow_8281_7967'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_8281_7967'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_8281_7967'
          x1='32'
          y1='2'
          x2='32'
          y2='50'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#EAB308' />
          <stop offset='1' stop-color='#EA8C08' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_8281_7967'
          x1='32'
          y1='2'
          x2='32'
          y2='42'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#151518' />
          <stop offset='1' stop-color='#EA8C08' />
        </linearGradient>
      </defs>
    </svg>
  );
}
